import React from 'react';

import Arrow from '../Arrow.jsx';

function BuilderControls(props) {
    const _handleMove = (dir) => {
        if (props.onBlockMove) {
            props.onBlockMove(dir, (blockId, pageId) => {
                const frame = document.getElementById(pageId);
                if (!frame || !frame.contentDocument) {
                    return;
                }
                setTimeout(() => {
                    const element = frame.contentDocument.getElementById(blockId);
                    if (!element || !element.getClientRects) {
                        return;
                    }
                    const rect = element.getClientRects()[0];
                    if (dir == -1 && rect.top < 0) {
                        // Moving up and cut off at the top of screen
                        frame.contentDocument.scrollingElement.scrollTop += rect.top;
                    } else if (dir == 1 && rect.bottom > frame.contentDocument.scrollingElement.offsetHeight) {
                        // Moving down and cut off at the bottom of screen
                        if (rect.height > frame.contentDocument.scrollingElement.offsetHeight) {
                            // Element is taller than scroll area => Make sure the top is visible
                            if (rect.top > frame.contentDocument.scrollingElement.offsetHeight) {
                                // Top is cut off
                                frame.contentDocument.scrollingElement.scrollTop += rect.top;
                            }
                        } else {
                            frame.contentDocument.scrollingElement.scrollTop += (rect.bottom - frame.contentDocument.scrollingElement.offsetHeight);
                        }
                    }
                }, 100)
            })
        }
    }
    const handleMoveDown = () => _handleMove(1)
    const handleMoveUp = () => _handleMove(-1)

    let className = 'builder__controls';
    if (props.label) {
        className += ' builder__controls--with__label';
    }
    return (
        <div className={className}>
            <Arrow direction="up" onClick={handleMoveUp} />
            <Arrow direction="down" onClick={handleMoveDown} />
            <div style={{ flex: 1 }} />
            {props.before}
            {
                props.label &&
                <div className="builder__controls--label">{props.label}</div>
            }
            {props.extras}
            {props.after}
            <div style={{ flex: 1 }} />
        </div>
    )
}

export default BuilderControls;

